var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5294 9.99997C5.47864 9.99997 7.0588 8.4198 7.0588 6.47056C7.0588 4.52133 5.47864 2.94116 3.5294 2.94116C1.58017 2.94116 0 4.52133 0 6.47056C0 8.4198 1.58017 9.99997 3.5294 9.99997Z",
    fill: "#2CB5E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4126 1.76612C4.02264 0.710399 5.16369 0 6.47065 0C8.41989 0 10.0001 1.58017 10.0001 3.5294C10.0001 4.83637 9.28965 5.97741 8.23393 6.58746C8.23487 6.54861 8.23535 6.50965 8.23535 6.47057C8.23535 3.87159 6.12846 1.7647 3.52948 1.7647C3.49041 1.7647 3.45144 1.76518 3.4126 1.76612Z",
    fill: "#2CB5E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.73cfde364f75b0aa83fc46f7e3d54e37.svg";
export { ForwardRef as ReactComponent };